import { ScreenType, useScreenType } from "@redotech/react-util/screen";
import { Flex } from "@redotech/redo-web/flex";
import { memo, type ReactNode } from "react";
import * as css from "./modalless-page-layout.module.css";

export interface ModallessPageLayoutProps {
  children: ReactNode;
  footer?: ReactNode;
  footerUiSelector?: string;
  fullWidth?: boolean;
  stickyFooter?: boolean;
  topBar?: ReactNode;
  uiSelector: string;
}

export const ModallessPageLayout = memo(function ModallessPageLayout({
  children,
  footer,
  footerUiSelector,
  fullWidth,
  stickyFooter = true,
  topBar,
  uiSelector,
}: ModallessPageLayoutProps) {
  const screen = useScreenType();
  const isDesktop = screen === ScreenType.DESKTOP;
  const footerElement = footer ? (
    <Flex
      borderColor="primary"
      borderStyle="solid"
      borderTopWidth="1px"
      data-ui={footerUiSelector ?? `${uiSelector}-footer`}
      dir="column"
      pb={isDesktop ? "6xl" : "xl"}
      px={isDesktop ? "6xl" : "xl"}
      shrink={0}
      w="full"
    >
      {footer}
    </Flex>
  ) : null;

  return (
    <Flex
      className={css.root}
      data-modalless-page=""
      data-ui={uiSelector}
      flexDirection="column"
      overflow="hidden"
      w="full"
    >
      {topBar}

      <Flex
        align="center"
        flexDirection="column"
        grow={1}
        justify={stickyFooter ? undefined : "space-between"}
        minH="none"
        overflowY="auto"
        px={isDesktop ? "xl" : "none"}
        shrink={1}
        w="full"
      >
        <Flex
          flexDirection="column"
          gap="3xl"
          maxW={fullWidth && isDesktop ? "6xl" : "2xl"}
          px={isDesktop ? (fullWidth ? "none" : "5xl") : "xl"}
          py={isDesktop ? "8xl" : "3xl"}
          w="full"
        >
          {children}
        </Flex>
        {!stickyFooter && footerElement}
      </Flex>

      {stickyFooter && footerElement}
    </Flex>
  );
});
